/**
 * This year's photos live in assets/staff/primary and assets/staff/hover.
 * Last year's primary files stay in assets/staff/old for anyone who has
 * not submitted a new photo yet. Hover only swaps if a new alt exists.
 * Andy's hover is a GIF.
 */
import placeholder from "../assets/staff/primary/placeholder.svg";

import alexia from "../assets/staff/primary/alexia.png";
import arya from "../assets/staff/primary/arya.png";
import aura from "../assets/staff/primary/aura.png";
import beam from "../assets/staff/primary/beam.png";
import claire from "../assets/staff/primary/claire.png";
import cece from "../assets/staff/primary/cece.png";
import daniel from "../assets/staff/primary/daniel.png";
import duru from "../assets/staff/primary/duru.png";
import isabella from "../assets/staff/primary/isabella.png";
import jacob from "../assets/staff/primary/jacob.png";
import jessi from "../assets/staff/primary/jessi.png";
import julius from "../assets/staff/primary/julius.png";
import keanu from "../assets/staff/primary/keanu.png";
import lana from "../assets/staff/primary/lana.png";
import malcolm from "../assets/staff/primary/malcolm.png";
import matty from "../assets/staff/primary/matty.png";
import mjellma from "../assets/staff/primary/mjellma.png";
import paula from "../assets/staff/primary/paula.png";
import ross from "../assets/staff/primary/ross.png";
import samyak from "../assets/staff/primary/samyak.png";
import sidd from "../assets/staff/primary/sidd.png";
import stephen from "../assets/staff/primary/stephen.png";
import victoria from "../assets/staff/primary/victoria.png";
import will from "../assets/staff/primary/will.png";

import andyAlt from "../assets/staff/hover/andy.gif";
import alexiaAlt from "../assets/staff/hover/alexia.png";
import aryaAlt from "../assets/staff/hover/arya.png";
import auraAlt from "../assets/staff/hover/aura.png";
import beamAlt from "../assets/staff/hover/beam.png";
import ceceAlt from "../assets/staff/hover/cece.png";
import claireAlt from "../assets/staff/hover/claire.png";
import danielAlt from "../assets/staff/hover/daniel.png";
import duruAlt from "../assets/staff/hover/duru.png";
import isabellaAlt from "../assets/staff/hover/isabella.png";
import jacobAlt from "../assets/staff/hover/jacob.png";
import jasperAlt from "../assets/staff/hover/jasper.png";
import jessiAlt from "../assets/staff/hover/jessi.png";
import juliusAlt from "../assets/staff/hover/julius.png";
import keanuAlt from "../assets/staff/hover/keanu.png";
import lanaAlt from "../assets/staff/hover/lana.png";
import malcolmAlt from "../assets/staff/hover/malcolm.png";
import mattyAlt from "../assets/staff/hover/matty.png";
import mjellmaAlt from "../assets/staff/hover/mjellma.png";
import paulaAlt from "../assets/staff/hover/paula.png";
import rossAlt from "../assets/staff/hover/ross.png";
import samyakAlt from "../assets/staff/hover/samyak.png";
import siddAlt from "../assets/staff/hover/sidd.png";
import stephenAlt from "../assets/staff/hover/stephen.png";
import victoriaAlt from "../assets/staff/hover/victoria.png";
import willAlt from "../assets/staff/hover/will.png";

import andyOld from "../assets/staff/old/primary/andy.jpeg";
import ceceOld from "../assets/staff/old/primary/Cece.jpeg";
import jasperOld from "../assets/staff/old/primary/Jasper.jpg";

const newPrimary: Record<string, string> = {
  abodet: alexia,
  avishwak: arya,
  asukapan: aura,
  rthampar: beam,
  chan48: claire,
  cbartin: cece,
  dschiffm: daniel,
  zhuseyni: duru,
  irszabo: isabella,
  jgrandch: jacob,
  jshin108: jessi,
  jmhochbe: julius,
  kherft: keanu,
  lyangmac: lana,
  mhembre: malcolm,
  mberman8: matty,
  mmisini: mjellma,
  psromero: paula,
  rmgoldba: ross,
  sjain80: samyak,
  snareddy: sidd,
  syang195: stephen,
  vlhernan: victoria,
  wjbernst: will,
};

const newHover: Record<string, string> = {
  avd: andyAlt,
  abodet: alexiaAlt,
  avishwak: aryaAlt,
  asukapan: auraAlt,
  rthampar: beamAlt,
  chan48: claireAlt,
  cbartin: ceceAlt,
  dschiffm: danielAlt,
  zhuseyni: duruAlt,
  irszabo: isabellaAlt,
  jgrandch: jacobAlt,
  jhall44: jasperAlt,
  jshin108: jessiAlt,
  jmhochbe: juliusAlt,
  kherft: keanuAlt,
  lyangmac: lanaAlt,
  mhembre: malcolmAlt,
  mberman8: mattyAlt,
  mmisini: mjellmaAlt,
  psromero: paulaAlt,
  rmgoldba: rossAlt,
  sjain80: samyakAlt,
  snareddy: siddAlt,
  syang195: stephenAlt,
  vlhernan: victoriaAlt,
  wjbernst: willAlt,
};

const oldPrimaryByLogin: Record<string, string> = {
  avd: andyOld,
  cbartin: ceceOld,
  jhall44: jasperOld,
};

export function staffImages(cslogin: string): { image: string; altImage: string } {
  const id = cslogin.toLowerCase();
  const image = newPrimary[id] ?? oldPrimaryByLogin[id] ?? placeholder;
  return {
    image,
    altImage: newHover[id] ?? image,
  };
}
